import styled from 'styled-components';
import { Btn } from 'components';

export const BtnAddCarInfoWrapper = styled.div`
    text-align: center;
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BtnAddCarInfo = styled(Btn)`
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
        margin-right: 4px;
    }
`;